export default __webpack_public_path__ + "static/media/startOfIndoorTraining.d33d1155.jpg";